import { render, staticRenderFns } from "./RemovePartsModal.vue?vue&type=template&id=95c0fa22&scoped=true"
import script from "./RemovePartsModal.vue?vue&type=script&lang=js"
export * from "./RemovePartsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95c0fa22",
  null
  
)

export default component.exports